import { useContext } from 'react';
import { createContext } from 'react';

import { ProductNameProps } from '../@types/ProductNameProps';

export const ProductNameContext = createContext<ProductNameProps>({} as ProductNameProps);

ProductNameContext.displayName = 'ProductName';

const ProductNameProvider = (props: ProductNameProps) => (
	<ProductNameContext.Provider value={props}>{props.children}</ProductNameContext.Provider>
);

export const useProductName = () => {
	const context = useContext(ProductNameContext);

	return context;
};

export default ProductNameProvider;
